module.exports = __webpack_public_path__ + "img/car_15.87320299.jpg";